// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "1.4.7/static/js/" + chunkId + "." + "b7e9558a" + ".chunk.js";
};